import React, { useMemo } from "react";
import SocialLogin from "react-social-login";
import { Button, CircularProgress } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  button: (props) => ({
    marginTop: 10,
    marginBottom: 5,
    width: "100%",
    height: "44px",
    lineHeight: "18px",
    background: props.background
      ? props.background
      : "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
    "&:hover": {
      backgroundColor: props.background
        ? props.background
        : "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
    },
    color: props.color,
    textTransform: "none",
    fontSize: "16px",
  }),
  startIcon: {
    marginRight: "18px",
  },
});

export function SocialButtonBase(props) {
  const { triggerLogin, iconcomponent, label, loading, disabled } = props;
  const IconComponent = iconcomponent;
  const classes = useStyles(props);
  return useMemo(
    () => (
      <Button
        className={classes.button}
        classes={{
          startIcon: classes.startIcon,
        }}
        variant="contained"
        startIcon={loading ? <CircularProgress size={20} /> : <IconComponent />}
        onClick={triggerLogin}
        color={"secondary"}
        disabled={disabled}
      >
        {label}
      </Button>
    ),
    [loading, classes, label, triggerLogin, disabled]
  );
}

export default SocialLogin(SocialButtonBase);
